/**
 * Site Search
 *
 * @selector [data-js-site-search]
 * @enabled true
 */
import BaseModule from '../../modules/BaseModule.js';

export default class SiteSearch extends BaseModule {
    init(element) {
        this.el = element;
        this.$el = $(element);

        this.on('change', this.onChange);

        return this;
    }
    onChange() {
        this.el.submit();
    }
}
